import React, { useState, useEffect } from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { appPaths } from 'config';
import SoftBadge from 'components/common/SoftBadge';
import vmImg from 'assets/img/generic/vm.png';
import { fromISOInUTC } from 'helpers/time';

const VMCard = ({ vm, onDelete, deleting }) => {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const detailPath = appPaths.vms.detail.replace(':id', vm.id);
  const created = fromISOInUTC(vm.created);
  const isSuspended = vm.status === 'suspended';

  const [dots, setDots] = useState('.');

  useEffect(() => {
    if (!deleting) return;
    const interval = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? '.' : prev + '.'));
    }, 500);
    return () => clearInterval(interval);
  }, [deleting]);

  const handleCardClick = e => {
    if (deleting || isSuspended) return;
    if (e.target.closest('.dropdown')) return;
    navigate(detailPath);
  };

  return (
    <Card
      className={`card-vm ${
        deleting || isSuspended ? 'opacity-50' : 'cursor-pointer'
      } ${hovered && !deleting && !isSuspended ? 'shadow' : 'shadow-sm'}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleCardClick}
    >
      <div className="flex-grow-1 overflow-hidden">
        <img
          src={vmImg}
          alt="Cloud Desktop"
          className="w-100 h-100 object-fit-cover"
        />
      </div>
      <Card.Body>
        <div className="d-flex align-items-center mb-1">
          <h6 className="mb-0 flex-grow-1 text-truncate me-2">
            {deleting ? `Deleting${dots}` : vm.name || vm.id.slice(0, 12)}
          </h6>
          {!deleting && (
            <>
              {isSuspended ? (
                <SoftBadge bg="danger" className="fs--2">
                  Suspended
                </SoftBadge>
              ) : (
                <SoftBadge bg="success" className="fs--2">
                  Active
                </SoftBadge>
              )}
              {vm.is_demo && (
                <SoftBadge bg="info" className="fs--2 ms-1">
                  Demo
                </SoftBadge>
              )}
            </>
          )}
          {!deleting && (
            <Dropdown className="ms-2">
              <Dropdown.Toggle
                variant="link"
                size="sm"
                className="px-1 py-0 text-muted shadow-none"
                bsPrefix="btn"
              >
                <FontAwesomeIcon icon="ellipsis-v" />
              </Dropdown.Toggle>
              <Dropdown.Menu align="end" className="py-1">
                <Dropdown.Item
                  className="text-danger py-1 fs--1"
                  onClick={() => onDelete(vm.id)}
                >
                  <FontAwesomeIcon icon="trash-alt" className="me-2" />
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
        <p className="mb-0 text-muted fs--1">
          {deleting ? '\u00A0' : created.toRelative()}
        </p>
      </Card.Body>
    </Card>
  );
};

export default VMCard;
